import { CustomLog } from './custom-log';
import { LogType } from '@infodata-group/inf-commons';

export class CustomLogDecorator {
  className: string;
  method: string;
  args: any;
  result: any;
  target: any;
  constructor(o: { method: string; args: any; result: any; target: any }) {
    this.className = o.target.constructor.name;
    this.method = o.method;
    this.args = o.args;
    this.target = o.target;
    this.result = o.result;
  }

  public toString(): string {
    return `[${this.className}.${this.method}]`;
  }
}

export class CustomLogFromDecorator extends CustomLog {
  public override data: CustomLogDecorator;

  constructor(o: CustomLogDecorator, type: LogType) {
    super(null, type);
    this.data = o;
  }

  public override toString(): string {
    return `${super.toString()} ${this.data.toString()}`;
  }

  public override console(): void {
    switch (this.type) {
      default:
        console.log(this.toString(), {
          object: this.data.target,
          args: this.data.args,
          result: this.data.result,
        });
    }
  }
}
